import { FC } from "react";
import { Outlet } from "react-router-dom";
import Header from "components/header/Header";
import Modal from "components/modal/Modal";
import Footer from "components/footer/Footer";

export const AppLayout: FC = () => (
  <>
    <Header />
    <Modal />
    <Outlet />
    <Footer />
  </>
);
